const cards = [
  {
    title: '高分纪录大片合集',
    tag: '纪录',
    desc: '精选豆瓣高分纪录大片，足不出户看遍世界精彩。高清画质带来沉浸式体验。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20scene%20with%20warm%20golden%20hour%20landscape%20photography%2C%20aerial%20view%20of%20nature%2C%20professional%20filmmaking%20aesthetic%2C%20rich%20earth%20tones%2C%20soft%20atmospheric%20lighting%2C%20epic%20scale%20composition&width=640&height=400&seq=card-doc-01&orientation=landscape',
  },
  {
    title: '经典港片怀旧专场',
    tag: '影视',
    desc: '重温黄金年代经典港片，从武侠到警匪，高清修复版带你回到那个传奇时代。',
    image: 'https://readdy.ai/api/search-image?query=Retro%20cinema%20atmosphere%20with%20warm%20vintage%20color%20grading%2C%20old%20Hong%20Kong%20street%20scene%20at%20dusk%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20nostalgic%20cinematic%20aesthetic%2C%20rich%20warm%20tones&width=640&height=400&seq=card-film-02&orientation=landscape',
  },
  {
    title: '爆笑综艺片段集锦',
    tag: '综艺',
    desc: '整理最搞笑的综艺名场面，轻松一刻不容错过。持续更新热门综艺精华。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20stage%20with%20vibrant%20lighting%2C%20entertainment%20studio%20atmosphere%2C%20energetic%20warm%20lighting%20design%2C%20cheerful%20ambiance%2C%20professional%20broadcast%20production%20quality&width=640&height=400&seq=card-variety-03&orientation=landscape',
  },
  {
    title: '创意短片精选系列',
    tag: '短片',
    desc: '全球创意短片精选，每一部都是视觉与思想的双重享受，激发你的创作灵感。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20creative%20studio%20setup%20with%20warm%20ambient%20lighting%2C%20filmmaking%20equipment%20on%20wooden%20desk%2C%20storyboard%20and%20lens%2C%20cinematic%20atmosphere%2C%20creative%20workspace%20aesthetic%2C%20warm%20and%20inviting&width=640&height=400&seq=card-short-04&orientation=landscape',
  },
  {
    title: '悬疑烧脑电影推荐',
    tag: '电影',
    desc: '精选高智商悬疑佳作，反转不断烧脑过瘾。每部都值得反复品味。',
    image: 'https://readdy.ai/api/search-image?query=Moody%20cinematic%20interior%20with%20warm%20amber%20lighting%2C%20vintage%20detective%20office%20atmosphere%2C%20shadow%20play%20on%20walls%2C%20mysterious%20yet%20warm%20ambiance%2C%20film%20noir%20aesthetic%20with%20modern%20color%20grading&width=640&height=400&seq=card-thriller-05&orientation=landscape',
  },
  {
    title: '旅行风光视觉盛宴',
    tag: '风光',
    desc: '足不出户环游世界，顶级风光摄影师的视觉大片。4K超清呈现极致美景。',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20golden%20sunset%20over%20mountain%20range%20with%20warm%20orange%20and%20amber%20sky%2C%20aerial%20landscape%20photography%2C%20dramatic%20clouds%2C%20rich%20earthy%20tones%2C%20epic%20natural%20scenery%2C%20cinematic%20composition&width=640&height=400&seq=card-travel-06&orientation=landscape',
  },
  {
    title: '音乐MV精选合集',
    tag: '音乐',
    desc: '全球热门音乐MV高清合集，视听双重享受。华语欧美日韩全面覆盖。',
    image: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20warm%20spotlight%20lighting%2C%20musical%20performance%20atmosphere%2C%20dynamic%20stage%20design%20with%20amber%20and%20golden%20lights%2C%20professional%20live%20music%20photography%2C%20energetic%20crowd%20silhouette&width=640&height=400&seq=card-music-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            精选推荐
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            为你精选
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            根据热门趋势为你推荐优质内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 6).map((card) => (
            <div
              key={card.title}
              className="rounded-xl overflow-hidden border border-background-200/60 bg-background-50 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="relative w-full h-48 overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-background-950/70 text-background-50 text-xs font-label font-medium whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5">
          <div
            className="rounded-xl overflow-hidden border border-background-200/60 bg-background-50 hover:border-accent-200 transition-colors cursor-pointer group flex flex-col sm:flex-row"
          >
            <div className="relative w-full sm:w-64 h-48 sm:h-auto shrink-0 overflow-hidden bg-background-200">
              <img
                src={cards[6].image}
                alt={cards[6].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 flex flex-col justify-center">
              <span className="inline-block px-2 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-label font-medium mb-2 w-fit whitespace-nowrap">
                {cards[6].tag}
              </span>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-1.5 group-hover:text-accent-600 transition-colors">
                {cards[6].title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{cards[6].desc}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}